import { Fragment } from 'react';

import { Typography, Descriptions, Col, Row, Divider } from 'antd';

import * as Constants from '../../constants';

const { Title } = Typography;

const CustomView = ({ items }) => {
  const itemsView = items?.map((section, sectionIndex) => {
    const cols = section?.cols?.map((col, colIndex) => {
      const formItems = col?.items?.map((item, itemIndex) => (
        <Descriptions.Item
          key={item?.key || item?.label || `item-${sectionIndex}-${colIndex}-${itemIndex}`}
          className={item?.className}
          contentStyle={Constants.STYLES.CONTENT}
          label={item?.label}
          labelStyle={Constants.STYLES.LABEL}>
          {item?.value ?? '-'}
        </Descriptions.Item>
      ));
      return (
        <Col key={col?.key || col?.title || `col-${sectionIndex}-${colIndex}`} span={col?.span || 12}>
          {!!col?.title && (
            <Title className="mb-30" level={3} style={Constants.STYLES.TITLE}>
              {col?.title}
            </Title>
          )}
          <Descriptions colon={false} column={1}>
            {formItems}
          </Descriptions>
        </Col>
      );
    });
    return (
      <Fragment key={section?.key || section?.title || `section-${sectionIndex}`}>
        {!!section?.title && (
          <Title className="mb-30" level={3} style={Constants.STYLES.TITLE}>
            {section?.title}
          </Title>
        )}
        <Row>{cols}</Row>
        {sectionIndex !== items?.length - 1 ? <Divider /> : null}
      </Fragment>
    );
  });

  return <>{itemsView}</>;
};

export default CustomView;
